import { TypographyOptions } from '@mui/material/styles/createTypography';
import colors from './colors';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    navMenu: React.CSSProperties;
    kpiLarge: React.CSSProperties;
    kpiMedium: React.CSSProperties;
    label: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    navMenu?: React.CSSProperties;
    kpiLarge?: React.CSSProperties;
    kpiMedium?: React.CSSProperties;
    label?: React.CSSProperties;
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    navMenu: true;
    kpiLarge: true;
    kpiMedium: true;
    label: true;
  }
}

const fontFamily =
  '"Pretendard Variable", Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", sans-serif';

/**
 * JUDAM type scale — Pretendard, tabular nums on KPI
 */
const typography: TypographyOptions = {
  fontFamily,
  h1: {
    fontWeight: 750,
    fontSize: '2.5rem', // 40 Display
    lineHeight: '52px',
    letterSpacing: '-0.03em',
    color: colors.text.primary,
  },
  h2: {
    fontWeight: 750,
    fontSize: '1.75rem', // 28 Page title PC
    lineHeight: '38px',
    letterSpacing: '-0.03em',
    color: colors.text.primary,
    '@media (max-width:767.95px)': {
      fontSize: '1.5rem', // 24 Mobile
      lineHeight: '34px',
    },
  },
  h3: {
    fontWeight: 700,
    fontSize: '1.25rem', // 20 Section
    lineHeight: '28px',
    letterSpacing: '-0.02em',
    color: colors.text.primary,
  },
  h4: {
    fontWeight: 650,
    fontSize: '1rem', // 16 Card title
    lineHeight: '24px',
    letterSpacing: '-0.01em',
    color: colors.text.primary,
  },
  h5: {
    fontWeight: 650,
    fontSize: '0.9375rem',
    lineHeight: 1.4,
    letterSpacing: '0',
    color: colors.text.primary,
  },
  h6: {
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: 1.4,
    letterSpacing: '0',
    color: colors.text.primary,
  },
  body1: {
    fontSize: '0.9375rem', // 15
    fontWeight: 450,
    lineHeight: '23px',
    letterSpacing: '0',
    color: colors.text.primary,
  },
  body2: {
    fontSize: '0.875rem', // 14
    fontWeight: 450,
    lineHeight: '21px',
    letterSpacing: '0',
    color: colors.text.secondary,
  },
  subtitle1: {
    fontSize: '0.9375rem',
    fontWeight: 600,
    lineHeight: '23px',
    letterSpacing: '0',
    color: colors.text.primary,
  },
  subtitle2: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '21px',
    letterSpacing: '0',
    color: colors.text.secondary,
  },
  button: {
    textTransform: 'none',
    fontWeight: 600,
    letterSpacing: '0',
  },
  caption: {
    fontSize: '0.75rem', // 12
    fontWeight: 500,
    lineHeight: '18px',
    letterSpacing: '0',
    color: colors.text.muted,
  },
  overline: {
    fontSize: '0.75rem',
    fontWeight: 600,
    lineHeight: '18px',
    letterSpacing: '0.02em',
    textTransform: 'none',
  },
  navMenu: {
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.4,
    letterSpacing: '0',
  },
  kpiLarge: {
    fontWeight: 750,
    fontSize: '2rem', // 32
    lineHeight: '40px',
    letterSpacing: '-0.03em',
    fontVariantNumeric: 'tabular-nums',
    color: colors.text.primary,
  },
  kpiMedium: {
    fontWeight: 750,
    fontSize: '1.5rem', // 24
    lineHeight: '32px',
    letterSpacing: '-0.03em',
    fontVariantNumeric: 'tabular-nums',
    color: colors.text.primary,
  },
  label: {
    fontSize: '0.8125rem', // 13
    fontWeight: 600,
    lineHeight: '18px',
    letterSpacing: '0',
    color: colors.text.secondary,
  },
};

export default typography;
